<div id="bpmn-editor" class="bpmn-editor-container">
  <div #stencil class="bpmn-editor-stencil"></div>
  <div #container class="bpmn-editor-graph-container"></div>
</div>
